export default "__VITE_ASSET__DKr0AUTl__"